import { Component, Input } from '@angular/core';
import { FormField } from '@shared/components/form/models/beans/form-field.abstract';

@Component({
    selector: 'textfield[form]',
    templateUrl: './textfield.component.html',
    styleUrls: ['./textfield.component.scss'],
})
export class TextfieldComponent extends FormField {
    @Input() noInputStyle: boolean;
    @Input() textEnd: boolean;
    @Input() isNumeric = false;
    @Input() maxFractionDigits: number = 2;
    @Input() maxIntegerDigits: number = 15;
    @Input() maxStringLength: number = null;

    // TODO: Warnings da rivedere
    // get isValid(): boolean {
    //   const control = this.form.get(this.fieldName);
    //
    //   if(!control) {
    //     return false
    //   }
    //
    //   if(!control.errors){
    //     return true
    //   }
    //
    //   // controllo se ci sono warning, se ci sono li tolgo
    //   const controlErrors = Object.assign({}, control.errors);
    //
    //   if(controlErrors.warnings){
    //     // tolgo i warning
    //     delete controlErrors.warnings
    //   }
    //
    //   return Object.keys(controlErrors).length === 0;
    // }
    //
    // get isInvalid(): boolean {
    //   return !this.isValid
    // }
    //
    // get isWarned(): boolean {
    //   const control = this.form.get(this.fieldName);
    //
    //   if(!control) {
    //     return false
    //   }
    //
    //   return this.isValid && control.hasError('warnings')
    // }
}
